import {
  Message,
  type MessageProps,
} from '@design/components/messages/message/Message'
import { OctagonX } from 'lucide-react'

export type ErrorMessageProps = Omit<MessageProps, 'icon' | 'iconClassName'>

export function ErrorMessage(props: ErrorMessageProps) {
  return (
    <Message
      icon={OctagonX}
      role='alert'
      iconClassName='bg-red-50 text-red-600 border-red-200'
      {...props}
    />
  )
}
